import { combineReducers } from "redux";
import { authentication } from "./authentication.reducer";
import { registration } from "./registration.reducer";
import {
  users,
  usersForImpersonation,
  user,
  listNotifications,
  notificationCount,
  policies,
  userTopCards,
  userPolicies,
  postPolicies,
  userFilters,
  userEdited,
  sessionInfo,
  onboarded,
  customerDetails,
  filterList,
  updloadPicture,
  allCardsForUser,
  checkUserName,
  activeUsers,
  loginDetails,
  verifySubscription,
  resendToken,
  setMpin,
  shareOverEmail,
  loginDetailsTopCards,
  userSessionFilters,
  aiNotification,
  isNewNotificationCount,
  notification,
  notificationOptions,
  register,
  isDomain,
  generateOTP,
  verifyOTP,
  resendOTP,
} from "./users.reducer";
import { alert } from "./alert.reducer";
import reducer from "./settings.reducer";

import {
  listAPIs,
  apiTopCards,
  apiDetails,
  testResult,
  filtersAPI,
  approveAPI,
} from "./apiExplorer.reducer";

import {
  createAccessControl,
  accessControlsDetails,
  accessControlsList,
  activeRoles,
  accessControlsTopCards,
  accessControlsPoliciesList,
  updateRole,
  updateAccessControlPolicies,
  accessControlFilters,
  activateAccessControl,
  deleteRole,
  navigationList,
  assignedUiNav,
  UiNavigationById,
  unAssignNavigation,
  accessPolicyList,
} from "./accessControls.reducer";
import {
  listReports,
  countAndUpdates,
  overviewChartData,
  overviewROIChartData,
  ideaDashboardDetails,
} from "./probytoaiOverview.reducer";
import {
  dashboardTopCard,
  dailyJobRunTrackerData,
  dashboardPieCharts,
  distinctConnections,
} from "./dashboard.reducer";
import {
  allMarketplaces,
  marketplaceConfigSubmission,
  activeCloudStorageByType,
  listInfraByMarketplaceId,
} from "./marketplace.reducer";
import {
  sourcesDestinationsByConnectionId,
  sourcesDestinationsEditById,
  sourcesDestinationsDeleteById,
} from "./sourcesDestinaion.reducer";
import {
  connectionsList,
  connectionsTopCard,
  activeSourceDestination,
  connection,
  connectionById,
  connectionByWorkspaceId,
  endPointsByConnectionId,
  configureConnection,
  editConnection,
  slackListIntegration,
  bitbucketListIntegration,
  connectionsFilters,
  activeConnection,
} from "./connections.reducer";
import {
  tablesList,
  tablesTopCard,
  tableById,
  dictionaryByTableId,
  table,
  tablesByConnectionId,
  dataDictionaryByTableId,
  configureTable,
  editTable,
  dataQualityEditById,
  dataQualityByTableId,
  dataQualityDeleteById,
  addConfiguredTable,
  tablesFilters,
  dataDictionary,
  activeTable,
  activeTableByConnectionId,
} from "./tables.reducer";
import {
  workflowList,
  workflowById,
  workflowTopCard,
  workflow,
  editWorkflow,
  addConfiguredWorkflow,
  runWorkflow,
  databricksJobStatus,
  workflowFilters,
  gitRepoByConnectionId,
  activeWorkflow,
  activeWorkflowByConnectionId,
} from "./workflow.reducer";
import {
  jobRunTrackerById,
  jobRunTrackerList,
  dataQualityChecks,
  dataJobStageQualityFilter,
} from "./dataJobRunTracker.reducer";
import {
  workspaceProfiles,
  activeWorkspaces,
  addWorkspace,
  editWorkspace,
  deleteWorkspace,
  workspaceProps,
} from "./workspace.reducer";

import { createData } from "./createData.reducer";

import {
  serviceSettingsList,
  serviceSettingsById,
  updateServiceSettingsByTypes,
  updateServiceSettingsByStatus,
} from "./serviceSettings.reducer";
import {
  listAccessEvents,
  listEventStatus,
  filtersAccessEvents,
  accessEventsTopCards,
} from "./accessEvents.reducer";
import {
  systemAuditList,
  systemAuditTopCard,
  fetchSystemAuditFilters,
} from "./systemAudit.reducer";
import {
  emailList,
  activeEmailList,
  postSettings,
} from "./emailSetting.reducer";

import {
  keyList,
  keyTopInfo,
  keyCreated,
  openAPIList,
  userOpenAPI,
  keyDetails,
  apiAssigned,
  keyFilterList,
  apiKeyFilters,
  deleteApiKey,
  updateApiKey,
  activateApi,
} from "./keyManagement.reducer";

import { activation } from "./activation.reducer";
import {
  adminDashboardCards,
  adminDashboardCharts,
} from "./adminDashboard.reducer";

import {
  assetAttachmentList,
  uploadAssetAttachment,
  assetHTMLDetails,
  updateAssetHTMlDetails,
} from "./commonUtil.reducer";
import {
  companyProfile,
  editCompany,
  companyLogo,
  dashboardDropdownData,
  costDashboardData,
} from "./company.reducer";
const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  usersForImpersonation,
  updloadPicture,
  userTopCards,
  userFilters,
  userEdited,
  sessionInfo,
  onboarded,
  customerDetails,
  alert,
  allCardsForUser,
  checkUserName,
  reducer,
  policies,
  userPolicies,
  postPolicies,
  activeUsers,
  loginDetails,
  verifySubscription,
  resendToken,
  setMpin,
  aiNotification,
  listAPIs,
  apiTopCards,
  apiDetails,
  testResult,
  listReports,
  countAndUpdates,
  overviewChartData,
  overviewROIChartData,
  workspaceProfiles,
  activeWorkspaces,
  addWorkspace,
  editWorkspace,
  user,
  filtersAPI,
  listNotifications,
  notificationCount,
  createData,
  approveAPI,
  serviceSettingsList,
  serviceSettingsById,
  updateServiceSettingsByTypes,
  updateServiceSettingsByStatus,
  listAccessEvents,
  listEventStatus,
  filtersAccessEvents,
  accessEventsTopCards,
  systemAuditList,
  systemAuditTopCard,
  emailList,
  activeEmailList,
  postSettings,
  keyList,
  keyTopInfo,
  keyCreated,
  openAPIList,
  userOpenAPI,
  keyDetails,
  deleteApiKey,
  updateApiKey,
  apiAssigned,
  accessControlsDetails,
  accessControlsList,
  activeRoles,
  accessControlsTopCards,
  accessControlFilters,
  updateRole,
  activateAccessControl,
  deleteRole,
  navigationList,
  assignedUiNav,
  UiNavigationById,
  accessPolicyList,
  unAssignNavigation,
  updateAccessControlPolicies,
  accessControlsPoliciesList,
  createAccessControl,
  fetchSystemAuditFilters,
  keyFilterList,
  apiKeyFilters,
  filterList,
  activation,
  shareOverEmail,
  adminDashboardCards,
  adminDashboardCharts,
  loginDetailsTopCards,
  userSessionFilters,
  ideaDashboardDetails,
  assetAttachmentList,
  uploadAssetAttachment,
  assetHTMLDetails,
  updateAssetHTMlDetails,
  companyProfile,
  allMarketplaces,
  marketplaceConfigSubmission,
  tablesList,
  tablesTopCard,
  tableById,
  workflowList,
  workflowById,
  workflowTopCard,
  jobRunTrackerById,
  jobRunTrackerList,
  dictionaryByTableId,
  deleteWorkspace,
  connectionsList,
  connectionsTopCard,
  activeSourceDestination,
  connection,
  connectionById,
  connectionByWorkspaceId,
  endPointsByConnectionId,
  table,
  tablesByConnectionId,
  configureConnection,
  editConnection,
  dataDictionaryByTableId,
  configureTable,
  dashboardTopCard,
  dailyJobRunTrackerData,
  dashboardPieCharts,
  editCompany,
  workflow,
  sourcesDestinationsByConnectionId,
  editTable,
  editWorkflow,
  dataQualityEditById,
  dataQualityByTableId,
  dataQualityDeleteById,
  sourcesDestinationsEditById,
  sourcesDestinationsDeleteById,
  addConfiguredTable,
  addConfiguredWorkflow,
  companyLogo,
  runWorkflow,
  databricksJobStatus,
  activeCloudStorageByType,
  listInfraByMarketplaceId,
  slackListIntegration,
  bitbucketListIntegration,
  workflowFilters,
  dataQualityChecks,
  dataJobStageQualityFilter,
  gitRepoByConnectionId,
  activeWorkflow,
  connectionsFilters,
  activeConnection,
  tablesFilters,
  dataDictionary,
  distinctConnections,
  activeTable,
  isNewNotificationCount,
  notification,
  notificationOptions,
  activateApi,
  workspaceProps,
  register,
  isDomain,
  generateOTP,
  verifyOTP,
  resendOTP,
  activeTableByConnectionId,
  activeWorkflowByConnectionId,
  dashboardDropdownData,
  costDashboardData,
});

export default rootReducer;
